export default "__VITE_ASSET__CJMHu8Bi__"